module.exports = __webpack_public_path__ + "img/img9.7d195f01.png";